export default __webpack_public_path__ + "static/media/large-installation-areas.7e7ac2b4.svg";